import {
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';

import { AppContent, ContentRow } from 'styled/components';
import TableHeader from 'components/table-header';
import ConfirmDeletion from 'components/confirm-deletion';
import LoadingIndicator from 'components/loading-indicator';
import useBEDatatable from 'hooks/use-be-datatable';

import { deleteContactTitle, getContactTitles } from './api-service';

function ContactTitles() {
  const navigate = useNavigate();

  const {
    ready,
    page,
    numberOfPages,
    rangeEnd,
    rangeStart,
    totalInstances,
    instancesList,
    selectedInstance,
    showDeleteConfirm,
    filter,

    setPage,
    filterChange,
    deleteInstance,
    setShowDeleteConfirm,
    handleDeleteButtonClicked,
  } = useBEDatatable({
    loadInstancesServiceAction: getContactTitles,
    deleteInstanceServiceAction: deleteContactTitle,
  });

  return (
    <>
      {!ready && <LoadingIndicator />}
      <AppContent>
        <TableHeader
          title="Contact titles"
          showAddButton
          handleAddButtonClicked={() => navigate('/contacts/titles/new')}
          filter={filter}
          filterChange={filterChange}
          firstItemIndex={rangeStart}
          lastItemIndex={rangeEnd}
          totalItems={totalInstances}
        />
        <ContentRow>
          {ready && (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="Contact titles table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell sx={{ width: 120 }} align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {instancesList.length > 0 && instancesList.map((_instance) => (
                    <TableRow
                      key={`contact-title-${_instance.id}`}
                      sx={{
                        td: { paddingTop: 1, paddingBottom: 1 },
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}
                    >
                      <TableCell>{_instance.name}</TableCell>
                      <TableCell sx={{ width: 120 }} align="right">
                        <IconButton
                          size="small"
                          aria-label="show title"
                          onClick={() => navigate(`/contacts/titles/${_instance.id}`)}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          aria-label="delete title"
                          onClick={() => handleDeleteButtonClicked(_instance)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {instancesList.length === 0 && (
                    <TableRow
                      sx={{
                        td: { paddingTop: 1, paddingBottom: 1 },
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}
                    >
                      <TableCell align="center" colSpan={2}>
                        <Typography>
                          There are no Contact titles yet. Add the first one by clicking the "Add new" button
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </ContentRow>
        {numberOfPages > 1 && (
          <ContentRow style={{ display: 'flex', justifyContent: 'center', columnGap: 16 }}>
            <Pagination
              count={numberOfPages}
              page={page}
              variant="text"
              shape="rounded"
              color="primary"
              showFirstButton
              showLastButton
              onChange={(ev, newPage) => setPage(newPage)}
            />
          </ContentRow>
        )}
      </AppContent>
      {showDeleteConfirm && (
        <ConfirmDeletion
          handleClose={() => setShowDeleteConfirm(false)}
          handleConfirm={() => deleteInstance(selectedInstance)}
          deleteInstanceMsg={`the Title: ${selectedInstance?.name || ''}`}
        />
      )}
    </>
  );
}

export default ContactTitles;
